import { makeStyles } from '@material-ui/core';

const useLogoStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  logo: {
    height: 'auto',
    width: '85%',
    maxHeight: '80px',
    objectFit: 'contain',
  },
  iconLogo: {
    height: 40,
    width: 40,
    objectFit: 'contain',
  },
});

export const MyCustomLogoFull = () => {
  const classes = useLogoStyles();
  
  return (
    <div className={classes.container}>
      <img 
        src="/badal-logo.png" 
        alt="Badal.io" 
        className={classes.logo}
      />
    </div>
  );
};

export const MyCustomLogoIcon = () => {
  const classes = useLogoStyles();
  
  return (
    <div className={classes.container}>
      <img 
        src="/badal-logo-small.png" 
        alt="Badal" 
        className={classes.iconLogo}
      />
    </div>
  );
};